// extracted by mini-css-extract-plugin
module.exports = {"considerations":"Considerations_considerations__2_tBE","strong":"Considerations_strong__3onG7"};